import { vm } from '@/main';
import { configure, extend } from 'vee-validate';
import { required, email, min, size } from 'vee-validate/dist/rules';
import { formatBytes } from '@services/helper.service.js';

export default {
    init: () => {
        configure({
            defaultMessage: (_, values) => {
                return vm.$t('Invalid field');
            }
        });

        extend('min', min);
        extend('size', {
            ...size,
            message: (name, params) => `${vm.$t('Max file size')} ${formatBytes(params.size)}`
        });
        extend('required', {
            ...required,
            message: () => vm.$t('Required field')
        });
        extend('email', {
            ...email,
            message: () => vm.$t('Not valid email')
        });
        extend('password', {
            params: ['target'],
            validate(value, { target }) {
                return value === target;
            },
            message: () => vm.$t('Password confirmation does not match')
        });
    }
};
